import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';
import settingIds from '../../constants/setting-ids';

const FILL_ATTRIBUTE_VALUE = 'fill';
const GROW_FILL_VALUE = '1';
const GROW_FIXED_VALUE = '0';

const convert = (attributeValue) => ({
  [breakpointKeys.DEFAULT]:
    attributeValue === FILL_ATTRIBUTE_VALUE ? GROW_FILL_VALUE : GROW_FIXED_VALUE,
});

export default [
  {
    scope: settingIds.ALL_COLUMNS,
    attribute: targetAttributes.WIDTH,
    classes: [targetClasses.GROW],
    childrenQuerySelector: ':scope > ws-column',
    convert,
  },
];
